import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged, debounce, timer } from 'rxjs';

export interface SpinnerState {
  isLoading: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
    private spinnerSubject = new BehaviorSubject<SpinnerState>({ isLoading: false });
    private requestCount = 0;

    show(): void {
        this.requestCount++;
        if (this.requestCount === 1) {
            this.spinnerSubject.next({ isLoading: true });
        }
    }

    hide(): void {
        this.requestCount = Math.max(0, this.requestCount - 1);
        if (this.requestCount === 0) {
            this.spinnerSubject.next({ isLoading: false });
        }
    }

    reset(): void {
        this.requestCount = 0;
        this.spinnerSubject.next({ isLoading: false });
    }

    /**
     * Force show the spinner (used by polling service)
     * Increments request count and shows spinner immediately with optional message
     * @param message Optional message to display with the spinner
     */
    forceShow(message?: string): void {
        this.requestCount++;
        this.spinnerSubject.next({ isLoading: true, message });
    }

    /**
     * Force hide the spinner (used on navigation)
     * Resets counter to 0 and hides immediately - more aggressive than reset()
     */
    forceHide(): void {
        this.requestCount = 0;
        this.spinnerSubject.next({ isLoading: false });
    }

    getSpinnerState(): Observable<SpinnerState> {
        return this.spinnerSubject.asObservable().pipe(
            debounce(value => value ? timer(0) : timer(150)),
            distinctUntilChanged()
        );
    }
}
